/**
 * @generated SignedSource<<d5b40d2c0f17a8f8133425826193736b>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserAssignmentTypesPanel_removeAssignmentTypesFromUserMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "RemoveAssignmentTypesFromUserPayload",
                    "kind": "LinkedField",
                    "name": "removeAssignmentTypesFromUser",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "UserAssignmentTypesPanel_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserAssignmentTypesPanel_removeAssignmentTypesFromUserMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "RemoveAssignmentTypesFromUserPayload",
                    "kind": "LinkedField",
                    "name": "removeAssignmentTypesFromUser",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssignmentTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "assignmentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "AssignmentType",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "title",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "bec04e12cf9bdaa0b5925b9d782dc85b",
            "id": null,
            "metadata": {},
            "name": "UserAssignmentTypesPanel_removeAssignmentTypesFromUserMutation",
            "operationKind": "mutation",
            "text": "mutation UserAssignmentTypesPanel_removeAssignmentTypesFromUserMutation(\n  $model: RemoveAssignmentTypesFromUserInput!\n) {\n  removeAssignmentTypesFromUser(model: $model) {\n    user {\n      ...UserAssignmentTypesPanel_user\n      id\n    }\n  }\n}\n\nfragment UserAssignmentTypesPanel_user on User {\n  assignmentTypes {\n    nodes {\n      id\n      title\n    }\n  }\n  id\n}\n"
        }
    };
})();
node.hash = "f7c7f79f5c764cf5205032a0f1007ef8";
export default node;
